export const resolveFeeProviderCategoryIds = (feeProviderCategoryIds, feeProviderCategoryId) => {
  if (feeProviderCategoryIds?.length > 0) {
    return feeProviderCategoryIds;
  }

  if (feeProviderCategoryId) {
    return [feeProviderCategoryId];
  }

  return [];
};

export const getAllowedCategoryIds = feeType =>
  resolveFeeProviderCategoryIds(feeType?.feeProviderCategoryIds, feeType?.feeProviderCategoryId);
